import React from 'react';
// import '../../src/custom.scss';
import { Link } from "react-router-dom";
import traveTourism from '../assets/images/pngicons/Travel-Tourism.png';

export default function FlipBoxAnimated() {
  return (


<> 

<h1 className='text-center'> Style 1 </h1>
    <section className='flipbox_section product_section'> 
    <div className='container mt-5 mb-5'>

        <div className='row'>



<div className='col-lg-4'>

<div className="flip-box">
    <div className="flip-box-inner">
        
        <div className="flip-box-front">
                <div className='products_wrapper'>

                <div className='icon_holder'><img src={traveTourism} alt=''></img> </div>
                <div className='title'>Travel & Tourism</div>
                <div className='description'>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt dolore magna aliqua.</p>
                </div>
                <div className='readmore'>
                <Link to='/'>Read More</Link>

                </div>

                </div>
        </div>

        <div className="flip-box-back">
                <div className='products_wrapper'>

                <div className='icon_holder'><img src={traveTourism} alt=''></img> </div>
                <div className='title'>Travel & Tourism</div>
                <div className='description'>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt dolore magna aliqua.</p>
                </div>
                <div className='readmore'>
                <Link to='/'>Read More</Link>

                </div>

                </div>
        </div>

    </div>
</div>


</div>

<div className='col-lg-4'>

<div className="flip-box">
    <div className="flip-box-inner">
        
        <div className="flip-box-front">
                <div className='products_wrapper'>

                <div className='icon_holder'><img src={traveTourism} alt=''></img> </div>
                <div className='title'>Travel & Tourism</div>
                <div className='description'>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt dolore magna aliqua.</p>
                </div>
                <div className='readmore'>
                <Link to='/'>Read More</Link>

                </div>

                </div>
        </div>

        <div className="flip-box-back">
                <div className='products_wrapper'>

                <div className='icon_holder'><img src={traveTourism} alt=''></img> </div>
                <div className='title'>Travel & Tourism</div>
                <div className='description'>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt dolore magna aliqua.</p>
                </div>
                <div className='readmore'>
                <Link to='/'>Read More</Link>

                </div>

                </div>
        </div>

    </div>
</div>


</div>

<div className='col-lg-4'>

<div className="flip-box">
    <div className="flip-box-inner">
        
        <div className="flip-box-front">
                <div className='products_wrapper'>

                <div className='icon_holder'><img src={traveTourism} alt=''></img> </div>
                <div className='title'>Travel & Tourism</div>
                <div className='description'>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt dolore magna aliqua.</p>
                </div>
                <div className='readmore'>
                <Link to='/'>Read More</Link>

                </div>

                </div>
        </div>

        <div className="flip-box-back">
                <div className='products_wrapper'>

                <div className='icon_holder'><img src={traveTourism} alt=''></img> </div>
                <div className='title'>Travel & Tourism</div>
                <div className='description'>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt dolore magna aliqua.</p>
                </div>
                <div className='readmore'>
                <Link to='/'>Read More</Link>

                </div>

                </div>
        </div>

    </div>
</div>


</div>
       
        </div>


    </div>
    </section>


<h1 className='text-center'> Style 2 </h1>

<section className='flipbox_section2 product_section'> 
<div className='container mt-5 mb-5'>

    <div className='row'>


<div className='col-lg-4'>

<div className="flip-box">
<div className="flip-box-inner">
    
    <div className="flip-box-front">
            <div className='products_wrapper'>

            <div className='icon_holder'><img src={traveTourism} alt=''></img> </div>
            <div className='title'>Travel & Tourism</div>
            <div className='description'>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt dolore magna aliqua.</p>
            </div>
            <div className='readmore'>
            <Link to='/'>Read More</Link>

            </div>

            </div>
    </div>

    <div className="flip-box-back">
            <div className='products_wrapper'>

            <div className='icon_holder'><img src={traveTourism} alt=''></img> </div>
            <div className='title'>Travel & Tourism</div>
            <div className='description'>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt dolore magna aliqua.</p>
            </div>
            <div className='readmore'>
            <Link to='/'>Read More</Link>

            </div>

            </div>
    </div>

</div>
</div>


</div>

<div className='col-lg-4'>

<div className="flip-box">
<div className="flip-box-inner">
    
    <div className="flip-box-front">
            <div className='products_wrapper'>

            <div className='icon_holder'><img src={traveTourism} alt=''></img> </div>
            <div className='title'>Travel & Tourism</div>
            <div className='description'>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt dolore magna aliqua.</p>
            </div>
            <div className='readmore'>
            <Link to='/'>Read More</Link>

            </div>

            </div>
    </div>

    <div className="flip-box-back">
            <div className='products_wrapper'>

            <div className='icon_holder'><img src={traveTourism} alt=''></img> </div>
            <div className='title'>Travel & Tourism</div>
            <div className='description'>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt dolore magna aliqua.</p>
            </div>
            <div className='readmore'>
            <Link to='/'>Read More</Link>

            </div>

            </div>
    </div>

</div>
</div>


</div>

<div className='col-lg-4'>

<div className="flip-box">
<div className="flip-box-inner">
    
    <div className="flip-box-front">
            <div className='products_wrapper'>

            <div className='icon_holder'><img src={traveTourism} alt=''></img> </div>
            <div className='title'>Travel & Tourism</div>
            <div className='description'>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt dolore magna aliqua.</p>
            </div>
            <div className='readmore'>
            <Link to='/'>Read More</Link>

            </div>

            </div>
    </div>

    <div className="flip-box-back">
            <div className='products_wrapper'>

            <div className='icon_holder'><img src={traveTourism} alt=''></img> </div>
            <div className='title'>Travel & Tourism</div>
            <div className='description'>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt dolore magna aliqua.</p>
            </div>
            <div className='readmore'>
            <Link to='/'>Read More</Link>

            </div>

            </div>
    </div>

</div>
</div>


</div>
   
    </div>


</div>
</section>
</>
  )
}
